import type { TFunction } from 'i18next';

import type { ChannelSettingSummary } from '../../api';
import type { SupportedLanguage } from '../../i18n';

import { formatBps, formatLots } from './formatters';

/**
 * "Risk 1 % · Automatic", "Fixed lot 0,05 · Confirmation": a channel's validated settings in one
 * line, as Home (M1, mockup 1) and the Channels tab (S9 R4, `GestionCanaux.html`) show them. The
 * texts stay under `home.channels.setting` where M1 put them.
 */
export function channelSettingLabel(
  setting: ChannelSettingSummary,
  t: TFunction,
  language: SupportedLanguage,
): string {
  const { sizing, executionMode } = setting;
  const size =
    sizing.mode === 'risk_percent'
      ? t('home.channels.setting.risk_percent', { value: formatBps(sizing.riskBps, language) })
      : t('home.channels.setting.fixed_lot', { value: formatLots(sizing.lots, language) });
  return t('home.channels.setting.summary', {
    size,
    mode: t(`home.channels.setting.${executionMode}`),
  });
}
